<template>
  <el-container>
    <el-header>
      <navmenu/>
    </el-header>
    <el-main>
      <div class="block">
        <el-carousel trigger="click" height="460px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgList" :key="item.name">
            <div class="pic_item">
              <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" />
              <h3>{{item.title}}</h3>
              <p>{{item.detail}}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="visualNav">
          <ul>
            <a href="#/visual/product"><li class="icon_a"><span></span>产品<div></div></li></a>
            <a href="#/visual/developmentPlatform"><li class="icon_b"><span></span>开发平台<div></div></li></a>
            <a href="#/visual/apply"><li class="icon_c actived"><span></span>可视化应用<div></div></li></a>
            <a href="#/visual/digitalTwin"><li class="icon_d"><span></span>数字孪生应用<div></div></li></a>
            <a href="#/visual/caseIntroduction"><li class="icon_e"><span></span>案例介绍</li></a>
          </ul>
        </div>
      </div>
      <div class="solution">
        <div class="share">
          <div style="height:45px;width:415px;margin:0 auto;"><h2>可视化应用</h2></div>
          <span></span>
        </div>
        <div class="view-tip">
          <p class="title">可视化应用</p>
          <div class="detail">
            <p>只要有足够的创意和对行业的认知程度，任何公司都可以通过我们的可视化开发平台方便快捷的创造出超出用户预期的交付产品。</p>
            <div class="productImg"><img src="../../../public/visualImg/apply1.png" alt=""> </div>
            <p style="margin-top:20px;">同时我们也提供了深度定制服务，没有行业限制、没有门槛限制，只需要提出要求，专业的团队就会与您联系。（邮箱：marketing@comzen.net）</p>
          </div>
        </div>
        <div class="view-tip">
          <p class="title">数字价值的可视化过程</p>
          <div class="detail">
            <p>不同场景需要选择不同的可视化技术手段，以用户目标为根本，构建可视化场景的多态性。</p>
            <div class="productImg"><img src="../../../public/visualImg/apply2.png" alt=""> </div>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer>
      <footerMenu/>
    </el-footer>
  </el-container>
</template>

<script>
import navmenu from '../../components/navmenu.vue';
import footerMenu from '../../components/footer.vue';

export default {
  components: { navmenu,footerMenu },

  data(){
    return{
      imgList:[
        {
          name: "banner1",
          title:'可视化',
          detail:'Visualization',
          src: require("../../../public/visualImg/visualbaner.png"),
        },
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.share{
  padding:80px 0 60px 0;
  span{
    height: 3px;
    width: 44px;
    display: inline-block;
    background-color: #C5C5C5;
  }
}

.block{
  position: relative;
  .pic_item {
    position: relative;
    height: 100%;
    h3{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 132px;        
      font-size: 60px;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:moveh3 3s infinite;
      // animation-iteration-count:1;
      @keyframes moveh3{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
      @-webkit-keyframes moveh3 /*Safari and Chrome*/{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
    }      
    p{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 242px;        
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:movep 3s infinite;
      @keyframes movep{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
      }
      @-webkit-keyframes movep /*Safari and Chrome*/{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
    }
    }      
  }
  .pic_item:hover{
    cursor: pointer;
  }
  .visualNav{
    width: 100%;
    height: 98px;
    margin-top: 60px;
    border-top: 1px solid rgba(51, 51, 51, 0.15);
    border-bottom: 1px solid rgba(51, 51, 51, 0.15);
    ul{
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      text-align: center;
      vertical-align: middle !important;
      a{width: 100%;}
      li{
        height: 100px;
        line-height: 100px;
        width: 100%;
        div{
          width: 1px;
          height: 20px;
          background:#ccc ;
          float: right ;
          margin-top: 40px;
        }
      }
      li:hover{
        cursor: pointer;
        // background-color:rgb(212,239,253);
        a{
          color: #fff;
        }
      }
      .icon_a{
        span{
          display: inline-block;
          background: url("../../../public/visualImg/icon_a.png") no-repeat;
          width:24px;
          height:24px;
          vertical-align: middle;
        }
        background-position-x: 70px;background-position-y: 38px;
      }
      .icon_a:hover{
        span{
          background: url("../../../public/visualImg/icon_a1.png") no-repeat;
        }
        background-position-x: 70px;background-position-y: 38px;
        background: linear-gradient(360deg, #23C2E3 0%, #1E8DD4 100%);
      }
      .actived {color: #fff;}
      .icon_b{
        span{
          display: inline-block;
          background: url("../../../public/visualImg/icon_b.png") no-repeat;
          width:24px;
          height:24px;
          vertical-align: middle;
        }
        background-position-x: 54px;background-position-y: 38px;
      }
      .icon_b:hover{
        span{
          background: url("../../../public/visualImg/icon_b1.png") no-repeat;
        }
        background-position-x: 54px;background-position-y: 38px;
        background: linear-gradient(360deg, #23C2E3 0%, #1E8DD4 100%);
      }
      .icon_c{
        span{
          display: inline-block;
          background: url("../../../public/visualImg/icon_c.png") no-repeat;
          width:24px;
          height:24px;
          vertical-align: middle;
        }
        background-position-x: 48px;background-position-y: 38px;
      }
      .actived,.icon_c:hover{
        span{

          background: url("../../../public/visualImg/icon_c1.png") no-repeat;
        }
        background-position-x: 48px;background-position-y: 38px;
        background: linear-gradient(360deg, #23C2E3 0%, #1E8DD4 100%);
      }
      .icon_d{
        span{
          display: inline-block;
          background: url("../../../public/visualImg/icon_d.png") no-repeat;
          width:24px;
          height:24px;
          vertical-align: middle;
        }
        background-position-x: 40px;background-position-y: 38px;
      }
      .icon_d:hover{
        span{

          background: url("../../../public/visualImg/icon_d1.png") no-repeat;
        }
        background-position-x: 40px;background-position-y: 38px;
        background: linear-gradient(360deg, #23C2E3 0%, #1E8DD4 100%);
      }
      .icon_e{
        span{
          display: inline-block;
          background: url("../../../public/visualImg/icon_e.png") no-repeat;
          width:24px;
          height:24px;
          vertical-align: middle;
        }
        background-position-x: 54px;background-position-y: 38px;
      }
      .icon_e:hover{
        span{

          background: url("../../../public/visualImg/icon_e1.png") no-repeat  ;
        }
        background-position-x: 54px;background-position-y: 38px;
        background: linear-gradient(360deg, #23C2E3 0%, #1E8DD4 100%);
      }
      
    }
    a{
      color: #333;
    }
    a:hover,a:active{
      color: #fff;
    }
  }
}

  .view-tip{
    width: 1200px;   
    margin: 0 auto;
    margin-bottom: 90px;
    text-align: left;
    .title{
      height: 33px;
      text-align: left;
      font-size: 24px;
      font-weight: bold;
      margin: 0 0 10px;
      padding-left: 10px;
      border-left: solid 3px #1E8DD4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre !important;
    }
    .detail{
      margin-top: 32px;
      text-align: left;
      font-size: 16px;
      line-height: 32px;
      color: #666;
      padding-left: 13px;
      p{
        margin-top:-3px
      }
      span{
        font-size: 18px;
        font-weight: bold;
        line-height: 20px;
        margin-bottom: 10px;
      }
      ul{
        list-style-type: none;
        margin-left: 5px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li{
          padding-bottom: 5px;
          width: 326px;
        }
      }
    }
  }
.productImg{
  img{
    width: 1200px;
    margin: 0 auto;
  }  
}
.solution{
  height:1460px;
}
</style>


// WEBPACK FOOTER //
// src/views/visual/apply.vue